import { RegionMemberGeneratedEntity } from "./generated/RegionMemberGeneratedEntity";

export abstract class RegionMemberEntity extends RegionMemberGeneratedEntity {
    // Comment to preserve new line
}
